import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { jsPDF } from 'jspdf';
import { Canvg } from "canvg";
import html2canvas from "html2canvas";
import { HttpClientModule } from '@angular/common/http';
import { EstimateListService } from './estimate-list-service'; // Adjust path if needed
import { Loading } from '../loading/loading';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'estimate-list',
  standalone: true,
  imports: [CommonModule, FormsModule,MatIconModule, Loading],
  templateUrl: './estimate-list.html',
  styleUrls: ['./estimate-list.scss']
})
export class EstimateList implements OnInit {
  searchQuery: string = '';
  services: any[] = [];
  estimateList: any[] = [];
  selectedCategoryId: number | null = null;
  selectedSubCategoryId: number | null = null;
  categories: any[] = [];
  subCategories: any[] = [];
  noServicesFound: boolean = false;
  vehicleData: any = null;
  loading = false;
  selectedMake: any;
  selectedModel: any;
  selectedYear: any;
  selectedVariant: any;
  selectedFuelType: any;
   garageKey: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private estimateService: EstimateListService
  ) {}


  ngOnInit(): void {
     this.route.paramMap.subscribe(params => {
      this.garageKey = params.get('key') || '';
      this.loadServices();
    });
    this.selectedMake=localStorage.getItem('selectedMake')
    this.selectedModel=localStorage.getItem('selectedModel')
    this.selectedYear=localStorage.getItem('selectedYear')
    this.selectedVariant=localStorage.getItem('variant')
    this.selectedFuelType=localStorage.getItem('fuelType')
    // Initialize services list
    // this.services = [
    //   {
    //     id: 1,
    //     title: "Comprehensive Service",
    //     category: "Brake Pads",
    //     price: "₹1,299",
    //     time: "⏱ 90–120 mins",
    //     tags: ["Genuine Parts", "Autoverse Assured"]
    //   },
    //   {
    //     id: 2,
    //     title: "Engine Oil Change",
    //     category: "Oil Change",
    //     price: "₹1,899",
    //     time: "⏱ 90–120 mins",
    //     tags: ["Warranty", "In-stock"]
    //   },
    //   {
    //     id: 3,
    //     title: "AC Gas Refill",
    //     category: "AC Service",
    //     price: "₹1,899",
    //     time: "⏱ 60–90 mins",
    //     tags: ["Warranty", "In-stock"]
    //   },
    //   {
    //     id: 4,
    //     title: "Rear Brake Pad Replacement",
    //     category: "Rear Brakes",
    //     price: "₹1,199",
    //     time: "⏱ 75–105 mins",
    //     tags: ["Warranty", "In-stock"]
    //   }
    // ];
    this.loadServices();
    // this.fetchServices();
    this.loadVehicleData();
  }

  // Filter services based on searchQuery
  get filteredServices() {
    if (!this.searchQuery.trim()) {
      return this.services;
    }
    const q = this.searchQuery.toLowerCase();
    return this.services.filter(s =>
      s.title.toLowerCase().includes(q) || s.category.toLowerCase().includes(q)
    );
  }
clearSearch() {
  this.searchQuery = '';
}

  // Add a service to estimate list
  addToEstimate(service: any) {
    if (this.estimateList.find(item => item.title === service.title)) {
      alert(service.title + " is already in estimate.");
      return;
    }
    this.estimateList.push({...service, quantity: 1});
  }

  // Remove service from estimate list
  removeFromEstimate(service: any) {
    this.estimateList = this.estimateList.filter(item => item.title !== service.title);
  }

  // Clear the entire estimate list
  clearEstimate() {
    this.estimateList = [];
  }
  

  // Increment or decrement quantity
  toggleQuantity(service: any, delta: number) {
    const svc = this.estimateList.find(item => item.title === service.title);
    if (svc) {
      svc.quantity = Math.max(1, svc.quantity + delta);
    }
  }
  // Check if a service is already added
isInEstimate(service: any): boolean {
  return this.estimateList.some(item => item.title === service.title);
}
 goToEstimateDetails(service:any) {
    this.router.navigate(['/estimate-details',service.id,service.title]);
  }
    downloadPDF() {
      // Find the element you want to capture
      const element = document.querySelector('.estimate-main-list-page') as HTMLElement;
      
      // Check if the element exists
      if (!element) {
        console.error('Element not found!');
        return;
      }

      // Capture the element and convert it into a canvas
      html2canvas(element, { scale: 2 }).then(canvas => {
        // Get image data from the canvas
        const imgData = canvas.toDataURL('image/png');

        // Create a new PDF document
        const pdf = new jsPDF('p', 'mm', 'a4'); // 'p' for portrait orientation

        // Get the image properties to maintain aspect ratio
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = 210; // A4 width in millimeters
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        // Add the image to the PDF document
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

        // Save/download the PDF with the given filename
        pdf.save('estimate-details.pdf');
      }).catch(err => {
        console.error('Failed to generate PDF:', err);
      });
    }
    loadServices() {
      this.loading = true;
      this.estimateService.getCategoriesAndSubCategories().subscribe({
        next: (response: any) => {
          if (response.code === 200 && response.data) {
            this.categories = response.data.categories;
            this.subCategories = response.data.subCategories;

            // Calculate count for each category
            this.categories.forEach(cat => {
              const subs = this.subCategories.filter(s => s.categoryId === cat.id);
              cat.subCategoryCount = subs.length;
            });

            // Select first category/subcategory by default
            if (this.categories.length) {
            this.selectedCategoryId = this.categories[0].id;
            const subs = this.subCategories.filter(s => s.categoryId === this.selectedCategoryId);
            if (subs.length) this.selectedSubCategoryId = subs[0].id;
          }

            // Assign services directly if present
            this.fetchServices();
          } else {
            console.error('API response invalid', response);
            this.loading = false;
          }
        },
        error: err => console.error('API error', err)
        
      });
    }

    mapCategories(data: any): any[] {
      const services: any[] = [];  // Explicit type annotation added
      if (data.categories) {
        data.categories.forEach((category: any) => {
          if (category.subcategories) {
            category.subcategories.forEach((sub: any) => {
              services.push({
                id: sub.id || sub.name, // fallback if id is missing
                title: sub.name,
                category: category.name,
                price: "₹0", // API may not provide price, adjust as needed
                time: "⏱ N/A", // default value
                tags: ["API Loaded"]
              });
            });
          }
        });
      }
      return services;
    }

    selectCategory(categoryId: number) {
      this.selectedCategoryId = categoryId;

      // Use correct property names from API response
      const subs = this.subCategories.filter(s => s.categoryId === categoryId);

      if (subs.length) {
        this.selectedSubCategoryId = subs[0].id; // assuming API returns subcategory id as `id`
      } else {
        this.selectedSubCategoryId = 0; // fallback if no subcategory
      }

      this.fetchServices();
    }


    selectSubCategory(subCategoryId: number) {
      this.selectedSubCategoryId = subCategoryId;
      this.fetchServices();
    }

    get filteredSubCategories() {
      if (!this.selectedCategoryId) return [];
      return this.subCategories.filter(s => s.categoryId === this.selectedCategoryId);
    }
    fetchServices() {
      let storedVariantKey = localStorage.getItem('variantKey');

      // If not found, try from vehicleData
      if (!storedVariantKey && this.vehicleData?.variantKey) {
        storedVariantKey = this.vehicleData.variantKey;
      }
      const garageKey = localStorage.getItem('garageKey') || '';

      const payload = {
         garageKey: garageKey,
        variantKey: storedVariantKey,
        categoryId: this.selectedCategoryId || 0,
        subCategoryId: this.selectedSubCategoryId || 0,
        deviceId: "String",
        deviceName: "String",
        source: "web",
        versionCode: 0,
        versionName: "String"
      };

      console.log('Calling API with payload:', payload);
      this.loading = true;

      this.estimateService.getServices(payload).subscribe({
        next: (response: any) => {
          this.loading = false;
          console.log("============service-list-api-response", response);

          if (response.code === 200 && response.data && response.data.services) {
            this.services = this.mapServices(response.data.services);
            this.noServicesFound = this.services.length === 0;
          } else if (response.code === 111) {
            this.services = [];
            this.noServicesFound = true;
            this.loading = false;
          } else {
            console.error('Service API response invalid', response);
            this.services = [];
            this.noServicesFound = true;
            this.loading = false;
          }
        },
        error: err => {
          console.error('Service API error', err);
          this.services = [];
          this.noServicesFound = true;
          this.loading = false;
        }
      });
    }


    mapServices(apiServices: any[]): any[] {
      return apiServices.map(service => ({
        id: service.id,
        title: service.name,
        category: "General Service", // or map as needed if you have categories elsewhere
        price: "₹0", // No price provided in API, set default or calculate if possible
        time: "⏱ N/A", // No time provided, set default or calculate
        tags: service.items ? service.items.map((item: { name: any; }) => item.name) : [],
        labourTotal : service.labourTotal
      }));
    }

     goToRegistrationDecode() {
    this.router.navigate(['/registration-decode']);
  }
loadVehicleData() {
  const data = localStorage.getItem('vehicleData');
  if (data) {
    const parsed = JSON.parse(data);

    this.vehicleData = {
      registrationNumber: parsed.registrationNumber,

      // normalize keys for both cases
      make: parsed.make || parsed.selectedMake,
      model: parsed.model || parsed.selectedModel,
      year: parsed.year || parsed.selectedYear,
      fuel: parsed.fuel || parsed.fuelType,

      variant: parsed.variant,
      rowKey: parsed.rowKey,
      variantKey: parsed.variantKey,
    };
  } else {
    this.vehicleData = {
      registrationNumber: '',
      make: '',
      model: '',
      year: '',
      fuel: '',
      variant: '',
      rowKey: '',
      variantKey: ''
    };
  }
}


}
